export default __webpack_public_path__ + "static/media/cross.bc6a8e82.svg";